import { render, staticRenderFns } from "./ProfilePreview.vue?vue&type=template&id=2c353449&"
import script from "./ProfilePreview.vue?vue&type=script&lang=js&"
export * from "./ProfilePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports